import Flex from '@Components/Bases/Flex';
import { Box, Button, Typography } from '@mui/material';
import CheckFormProgress from './CheckFormProgress';
import CheckProgress from './CheckProgress';

type SidebarItemProps = {
  title: string;
  isSelected: boolean;
  onSelect: () => void;
  isDisabled?: boolean;
  subItems?: {
    thProgress?: boolean;
    enProgress?: boolean;
    isPass?: boolean;
    date?: string;
    publish?: boolean;
    hideProgress?: boolean;
  }[];
};

const SidebarItem = ({
  title,
  isSelected,
  onSelect,
  subItems,
  isDisabled,
}: SidebarItemProps) => (
  <Flex alignItems="center" width={1}>
    <Button
      variant="text"
      onClick={onSelect}
      disabled={isDisabled}
      sx={{
        position: 'relative',
        backgroundColor: isSelected ? 'orange.100' : 'transparent',
        textAlign: 'left',
        width: '100%',
        padding: '10px 16px',
        '&:hover': {
          backgroundColor: 'orange.200',
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {subItems?.map((subItem, index) => {
        if (subItem.hideProgress) return null;
        return (
          <Flex key={`subItem-${index}`} gap={8}>
            <>
              {subItem.thProgress !== undefined &&
              subItem.enProgress !== undefined ? (
                <Flex mr={1} gap={0.5}>
                  <CheckFormProgress
                    key={`TH-${index}`}
                    progress={subItem.thProgress}
                    language="TH"
                  />
                  <CheckFormProgress
                    key={`EN-${index}`}
                    progress={subItem.enProgress}
                    language="EN"
                  />
                </Flex>
              ) : (
                <CheckProgress
                  key={`CheckProgress-${index}`}
                  isPass={Boolean(subItem.isPass)}
                  disabled={Boolean(isDisabled)}
                />
              )}
            </>
          </Flex>
        );
      })}
      <Typography
        sx={{ flex: 1 }}
        color={isDisabled ? 'grey.600' : 'text.primary'}
      >
        {title}
      </Typography>
      <Box
        right={0}
        top={0}
        bottom={0}
        width="4px"
        margin="2px 4px"
        position="absolute"
        bgcolor={isSelected ? 'primary.main' : 'transparent'}
        borderRadius="4px"
      />
    </Button>
  </Flex>
);

export default SidebarItem;
